<template>
  <div class="payment">
    <div
      class="title is-4 has-text-link has-text-left"
      style="padding-top: 15px; margin-bottom: 2px"
    >
      <img
        src="../../public/img/icons/round-96x96.png"
        style="height: 45px; margin-left: 10px; margin-top: -6px"
        @click="goHome"
      />
      <span
        class="has-text-link"
        style="position: relative; top: -15px; padding-left: 10px"
        >{{ $t("delivery.order-payment") }}</span
      >
      <!-- <span
        class="button icon is-medium is-pulled-right is-link is-outlined"
        style="margin-right:12px; margin-top:-5px; height:32px; padding:4px"
        @click="goHome"
      >
        <i class="fa fa-home" />
      </span>-->
      <a
        class="button icon is-medium is-pulled-right is-primary is-outlined"
        style="margin-right: 12px; margin-top: -5px; height: 32px; padding: 4px"
        href="https://m.me/tukapp"
        target="_blank"
      >
        <i class="fa fa-question" />
      </a>

      <!-- <label class="label has-text-link" style="font-size:1.6em">TUK Digital Payment</label> -->
    </div>
    <div class="notification" style="padding-top: 0">
      <!-- <div style="height:12px" /> -->

      <div class="field tags has-addons">
        <span class="single-line" style="padding-bottom: 5px">
          <span class="tag is-dark is-medium w150">
            <i class="fa fa-store-alt" />
            &nbsp;{{ translateCategory(businessType) }}
          </span>
          <span class="tag is-white is-medium has-text-weight-medium">{{
            businessName
          }}</span>
        </span>
      </div>

      <div class="field tags has-addons">
        <span class="single-line" style="padding-bottom: 5px">
          <span class="tag is-info is-medium w150">
            <!-- <i class="fa fa-phone" /> &nbsp;-->
            {{ $t("delivery.payment-method") }}
          </span>
          <span
            class="tag is-white is-medium has-text-link has-text-weight-medium"
            >{{ prettyPaymentMethod }}</span
          >
          <!-- <span
            v-if="paymentID"
            class="tag is-info is-medium has-text-weight-medium"
          >{{ paymentID }}</span>-->
        </span>
      </div>

      <div v-if="paymentID" class="field tags has-addons">
        <span class="single-line" style="padding-bottom: 5px">
          <span class="tag is-primary is-medium w150">
            <!-- <i class="fa fa-phone" /> &nbsp;-->
            Payment ID
          </span>
          <span class="tag is-white is-medium has-text-weight-medium">{{
            paymentID
          }}</span>
        </span>
      </div>

      <div v-if="isBankAccountPayment" class="field tags has-addons">
        <span class="single-line" style="padding-bottom: 5px">
          <span class="tag is-primary is-medium w150">Account Name</span>
          <span class="tag is-white is-medium has-text-weight-medium">{{
            accountName
          }}</span>
        </span>
      </div>

      <div class="field tags has-addons">
        <span class="single-line" style="padding-bottom: 10px">
          <span class="tag is-link is-medium w150">
            <!-- <span class="icon">฿</span> &nbsp;-->
            {{ $t("delivery.order-amount") }}
          </span>
          <span
            class="tag is-white is-medium has-text-link has-text-weight-medium"
            >{{ currencySymbol(country) }}{{ price }}</span
          >
        </span>
      </div>

      <div v-if="isBankAccountPayment">
        <p class="has-text-link" style="padding-top: 16px">
          Please pay the amount via bank transfer.
          <br />
          <br />
          After completion please share the payment confirmation with the
          {{ businessType }}
          <br />🙏🏽
        </p>
        <div style="height: 12px" />
        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              @click="paymentCompleted"
              :disabled="!paymentDone"
            >
              <i class="fa fa-check" />&nbsp;Payment Completed
            </button>
          </div>
        </div>
      </div>

      <div v-if="isCashPayment">
        <p class="has-text-link" style="padding-top: 16px">
          {{ $t("delivery.please-pay-cash-1") }}
          <br />
          {{ $t("delivery.please-pay-cash-2") }} 🙏🏽
        </p>
        <div style="height: 12px" />
        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              @click="paymentCompleted"
            >
              <i class="fa fa-check" />
              &nbsp;{{ $t("submit-order") }}
            </button>
          </div>
        </div>
      </div>
      <div v-if="isQRCodePayment">
        <div class="qr-wrapper">
          <qr-canvas :options="options" id="qr-code"></qr-canvas>
        </div>
        <p class="has-text-link" style="padding-top: 6px">
          Scan QR Code with your mobile banking app, or enter the
          {{ this.paymentMethod }} ID and amount.
        </p>
        <p class="has-text-link" style="padding-top: 16px">
          After payment is complete please send the confirmation to the shop. 🙌🏽
        </p>
        <!-- <input class="input" type="text" v-model="url" /> -->
        <div style="height: 12px" />
        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth is-rounded"
              @click="paymentCompleted"
              :disabled="!paymentDone"
            >
              <i class="fa fa-check" />&nbsp;Payment Completed
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QRCanvas } from "qrcanvas-vue";
const paynow = require("paynow-generator").paynowGenerator;
const generatePayload = require("promptpay-qr");

export default {
  name: "Payment",
  components: {
    QrCanvas: QRCanvas,
  },
  data() {
    return {
      price: null,
      accountName: null, // for bank transfers only
      paymentID: null,
      paymentMethod: null,
      paymentTimer: false,
      createdBy: null,
      phoneNumber: null,
      businessType: null,
      businessName: null,
      country: null,
      paymentCode: "", //"https://tukapp.co/qr/a",
      logo: "/img/icons/round-96x96.png", // 180x180
      // QR code generator options
      options: {
        cellSize: 8,
        correctLevel: "H",
      },
    };
  },
  computed: {
    paymentDone() {
      return this.paymentTimer;
    },
    isQRCodePayment() {
      if (this.paymentMethod === "PromptPay") return true;
      if (this.paymentMethod === "PayNow") return true;
      return false;
    },
    isCashPayment() {
      if (this.paymentMethod === "cash") return true;
      return false;
    },
    isBankAccountPayment() {
      if (this.paymentMethod === "Bank Account") return true;
      return false;
    },
    prettyPaymentMethod() {
      if (!this.paymentMethod) return null;
      // return this.capitaliseFirstLetter(this.paymentMethod);
      return this.translatePayment(this.paymentMethod);
    },
  },
  created() {
    const image = new Image();
    image.src = this.logo;
  },
  mounted() {
    if (!this.validQuery()) return;
    var query = this.$route.query;
    this.price = parseFloat(query.price);
    // this.promptPayID = query.prompt_pay; //"0909588716";
    // this.promptPay = this.generatePromptPay();
    this.paymentMethod = query.payment_method;
    this.paymentID = query.payment_id;
    if (this.isBankAccountPayment) {
      var str = this.paymentID;
      this.paymentID = str.split(",")[0];
      this.accountName = str.split(",")[1];
    }
    this.createdBy = query.created_by;
    this.phoneNumber = query.phone_number;
    this.businessType = query.business_type;
    this.businessName = query.business_name;
    this.country = query.country;
    if (this.isQRCodePayment) {
      this.paymentCode = this.getPaymentCode();
      this.generateQRCode();
    }
    // check price and promptPayID are not null and show error message
    setTimeout(() => (this.paymentTimer = true), 30000); // wait 30 seconds
  },
  methods: {
    validQuery() {
      if (!this.$route.query.price || !this.$route.query.payment_method) {
        var msg = `This payment link is invalid.<br><br>Please contact the shop.`;
        this.warningAlert(msg);
        return false;
      }
      return true;
    },
    getPaymentCode() {
      if (this.paymentMethod === "PromptPay") return this.generatePromptPay();
      if (this.paymentMethod === "PayNow") return this.generatePayNow();
      return "ERROR";
    },
    notifyBusiness() {
      var msg = `${this.phoneNumber} says they completed payment 🥳 Remember to call a delivery driver !! 🚚`;
      this.sendPushNotification(msg, this.createdBy);
    },
    paymentCompleted() {
      this.notifyBusiness();
      this.thankYou(`${this.$t("delivery.sign-in-to-track")} 🥳🥂🦜`);
      setTimeout(() => this.goHome(), 2000);
    },
    generateQRCode() {
      const image = new Image();
      image.src = this.logo;
      image.onload = () => {
        this.options = Object.assign({}, this.options, {
          // logo: { image },
          data: this.paymentCode,
        });
      };
    },
    generatePromptPay() {
      return generatePayload(this.paymentID, { amount: this.price });
    },
    generatePayNow() {
      // TODO check the QR code...was not working for me
      var id = this.paymentID;
      var type = "mobile"; // or UEN
      if (this.isUEN(id)) type = "UEN";
      var edit = "yes";
      var shopName = "Mala House"; //this.shopName;
      var comments = "Thank you for ordering with us";
      return paynow(type, id, edit, this.price, shopName, comments);
      // return paynow("UEN", id, "yes", "101.6", "", "");
    },
    isUEN(str) {
      var last = str.charAt(str.length - 1);
      return last.match(/[a-z]/i); // succeeds for lower or uppercase letters
    },
  },
};
</script>

<style scoped lang=scss>
.notification {
  padding: 1rem;
  padding-bottom: 8px;
}
.qr-wrapper {
  max-height: 95vw; /* setting height to width so it's a square 95vw*/
}
canvas {
  width: 80%;
  height: 80%;
  padding: 1px;
  border: 3px solid gold;
  border-radius: 5px;
}
.field {
  margin-bottom: 0;
}
.w150 {
  width: 150px;
}
.tag {
  margin-bottom: 0px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
</style>